export const GENERATED_IDS = {
    "__TALENT_ID": {
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {
                "PITCH_BLACK": "ef337e68-02bd-4702-9df7-833a24afe198"
            },
            "HAVOC": {
                "PITCH_BLACK": "3df7f1ed-388a-432c-aae9-d89a6c413c02"
            }
        },
        "EVOKER": {
            "DEVA": {
                "SPIRAL": "55d7ee77-ed89-41a1-b455-3e970e6b7953"
            },
            "PRES": {
                "TEMPORAL_ARTIFICER": "6404320f-c19f-48f6-b39b-bbe984b2025d",
                "DREAM_FLIGHT": "22bf8521-2831-41ad-a5a5-a62a3d43bc81",
                "SPIRAL": "aeec4741-91dd-4594-8beb-123c85ea78d3",
                "EM_COM": "dcf18038-8a03-4a87-86d0-e6d42a164387",
                "ERASURE": "25ecce2b-54db-4b4a-8b45-242aa720ac22"
            }
        },
        "DRUID": {
            "GUARDIAN": {
                "IMPROVED_ROAR": "0d3830e0-ce80-452a-bb5f-18ed279a0367"
            },
            "FERAL": {
                "IMPROVED_ROAR": "239e81c1-01b0-408c-a3ea-5d83e39ac762",
                "VIGIL": "a822f63b-ce23-47b4-af79-103272ccadf2"
            },
            "RESTO": {
                "INNER_PEACE": "b24d7519-c71a-45b0-ae8f-8f67d8d49486",
                "CEN_GUIDANCE": "ecf862d2-1f5d-4051-8b60-394f7658c650",
                "IMPROVED_ROAR": "6a5f13d8-3c24-4fcc-a52a-646e94c7a633",
                "IMPR_IRONBARK": "3065c3e8-d777-4470-9fca-84e3eb17df85",
                "CONVOKE": "acfbbbfe-ac5a-4c11-a3ea-abaf9a35d147",
                "TREE": "4c29d131-36ef-4125-b048-b40247ce5aeb"
            },
            "BALANCE": {
                "IMPROVED_ROAR": "dc9b1ac3-975e-4847-bcf1-830b8bffa784",
                "VIGIL": "948a984b-eac3-413c-bc5d-2a723950c9a3"
            }
        },
        "DK": {
            "UNHOLY": {},
            "FROST": {},
            "BLOOD": {}
        },
        "PALADIN": {
            "RET": {
                "IMP_BLESSING": "e2840ef9-93a4-42bc-856a-c077173ec6cb",
                "UNBREAK_SPIRIT": "c768ec00-4292-4429-89d6-16338f1f48a0"
            },
            "PROT": {
                "IMP_BLESSING": "c26f8c64-5da8-42a3-a32e-d1699572fb58",
                "UNBREAK_SPIRIT": "f626c934-6cf8-4f8f-8841-96202a0c7d5f",
                "COUNSEL_2_2": "d6d2ec6a-7fd2-4e91-b0c4-22a1b0006690",
                "COUNSEL_1_2": "0642e83e-260b-4b68-a9f7-d8ea014f63af"
            },
            "HOLY": {
                "IMP_BLESSING": "cde03164-1f42-4fb3-b35d-8a1a67cd67a3",
                "BOP": "54829dae-e511-41e0-b84d-a2c7f7118193",
                "HOLY_AVENGER": "ab80adb7-32c5-4f56-ac5a-e409b7dbbe8c",
                "CRUSADER": "61c37b98-60a2-44e1-ba66-0fdf77e8672f",
                "UNWAVERING_SPIRIT": "b4459e28-d8a8-4b10-8eb8-5d33bb8f2d41",
                "UNBREAK_SPIRIT": "17741eb6-03a6-4415-b3aa-1ac530d2c15f",
                "TYR_DELIVERANCE": "9f3e900e-d603-4680-a9d5-f15fda9fc476",
                "SAC_JUST": "1fa30335-b205-426c-b05b-1336b6909284"
            }
        },
        "HUNTER": {
            "MM": {
                "BORN_TO_BE_WILD_1_2": "219473f5-4a55-4a40-8b14-5353e2295484",
                "BORN_TO_BE_WILD_2_2": "f9dc4b6a-fc03-418c-8553-c48ad55e7ac0"
            },
            "SV": {
                "BORN_TO_BE_WILD_1_2": "c8e80f4b-eefb-4f31-b295-3d8385dabec6",
                "BORN_TO_BE_WILD_2_2": "df268adf-2a25-496d-b38a-5c8fa0cdd5c0"
            },
            "BM": {
                "BORN_TO_BE_WILD_1_2": "e8feba38-2390-472a-8c0f-d53453b7e0a3",
                "BORN_TO_BE_WILD_2_2": "f06ee4cf-d80b-4cbc-b894-b125945d54b6"
            }
        },
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {
                "HPPOT": "9a601219-977a-4013-81bc-2d45fd4a62ec",
                "PERSONAL2MIN": "ac075186-5490-4191-bee9-1ec0823abdf7",
                "HS": "aaf37b95-0085-4639-9602-be6b1753278a"
            }
        },
        "WARRIOR": {
            "PROT": {},
            "FURY": {},
            "ARMS": {}
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "PRIEST": {
            "DISC": {},
            "HOLY": {
                "SALV": "f3481c35-2189-4f11-b8de-5e86dd101420"
            },
            "SHADOW": {
                "SANLAYN": "81b4f418-a848-425c-b233-19adc9483cca"
            }
        },
        "SHAMAN": {
            "ENH": {
                "ANCE_GUIDE": "2af369b8-61ce-41b0-b5b5-ae44989730ca",
                "WRT": "7b7c8cac-4bb2-471f-8930-6ded0c65dfc3"
            },
            "ELE": {
                "ANCE_GUIDE": "cb550fdf-9247-4ba7-810d-bf67a7521a9b",
                "WRT": "162019f6-c1da-47c2-8f26-fa424834d3ce"
            },
            "RESTO": {
                "ASC": "851b8250-fcd0-441d-8e38-e00fc49fbb3e",
                "ANCE_GUIDE": "4538ad0b-71d9-4839-8693-ad4ae30cace0",
                "APT": "6a915c76-3b01-4cbb-8392-41cf5f0fd833",
                "WRT": "cda274b2-d1a6-4309-b051-f7fec31494ee"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "CHRYS": "69605da8-583a-4ad5-b6f6-f23200f222ee",
                "GIFT_OF_CELEST": "0f57e653-9046-402a-9ad8-0c61943cdd1b",
                "CHI_JI": "4f6ebcea-8838-47c9-bade-9bafa25cf2f0"
            },
            "BRM": {}
        }
    },
    "__MODIFIER_ID": {},
    "__SPELL_ID": {
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {
                "DARKNESS": "e04e4685-3c6e-4613-ba98-52be2140bfc8"
            },
            "HAVOC": {
                "DARKNESS": "371ee993-0b37-4c5c-b7ee-fbf47922c12a"
            }
        },
        "EVOKER": {
            "DEVA": {
                "SPIRAL": "4dc12356-09a3-4442-a7dd-8746b5ae98c6"
            },
            "PRES": {
                "DREAM_FLIGHT": "dd0ea003-497d-4f6a-b1dd-c8c3ff0a8ad5",
                "REWIND": "726d5073-10f7-40ba-a1f3-e818e7afd765",
                "TIME_DIALATION": "bd18abad-602e-47fd-a585-3c578a81577c",
                "SPIRAL": "1695c86e-1a64-45ef-aa57-8e0810a98d26",
                "EM_COM": "907c88f7-71a2-4c4e-adc1-57b2b8236319"
            }
        },
        "DRUID": {
            "GUARDIAN": {
                "ROAR": "0b83b018-d870-4859-935a-02b02a8910d7"
            },
            "FERAL": {
                "ROAR": "4c530f97-f5bf-4a44-9ef4-7665d52443d9",
                "VIGIL": "142cc025-1301-4a24-b1fa-ce9566dd5841"
            },
            "RESTO": {
                "TRANQ": "0ab91fcd-99e3-4658-82de-dd8e273414b7",
                "CONVOKE": "9f7d877c-1c50-473e-a468-af9e8b53a9c8",
                "FLOURISH": "db2f009b-fadb-4b1a-9b9b-c61d54222f9d",
                "ROAR": "f611f7ca-0af0-4ad8-96a9-5a82046051dc",
                "TREE": "767fb9b7-37dd-42ba-a40c-3ebc4acb4010",
                "IRONBARK": "1510469a-9ba1-43c1-b4c2-f2123f0253b7"
            },
            "BALANCE": {
                "ROAR": "24cf7d57-3e53-45f3-8876-ec2656ed4d1a",
                "VIGIL": "50a20f10-dc02-4054-8350-8d3d1b38aeda"
            }
        },
        "DK": {
            "UNHOLY": {
                "AMZ": "96b10617-767b-4ecf-b738-4dd14bc3cfb9"
            },
            "FROST": {
                "AMZ": "85ee4c18-8aeb-4e09-b6c4-812dc9fe40d8"
            },
            "BLOOD": {
                "AMZ": "05a72789-b350-4e67-bfe4-a6f5744a0582"
            }
        },
        "PALADIN": {
            "RET": {
                "BOP": "d415b75d-2e26-494d-8ac3-e3990d72e552",
                "DIV_SHIELD": "8edd711a-28da-4864-ba9d-1f00f6a46931"
            },
            "PROT": {
                "BOP": "1dd20438-062e-41fc-9b60-150a12e205d8",
                "DIV_SHIELD": "090a619e-1731-4389-84bf-824066221b68",
                "SPELLWARDING": "462ad886-4345-4fad-85fa-fac8e903e14b"
            },
            "HOLY": {
                "BOP": "1a2d4e71-b8d1-4493-a738-f71eaeb3b066",
                "DIV_SHIELD": "87736791-5723-4077-a94e-0735a5e83caf",
                "HOLY_AVENGER": "1c9cd6e6-241a-4898-97cd-2073a87cd100",
                "WINGS": "a721705c-3168-460c-8848-b8f49ec56edc",
                "CRUSADER": "62c12f15-fc62-4829-8e3b-19331db707ff",
                "TYR_DELIVERANCE": "30612a47-b815-4536-80c4-9591b5cfb835",
                "AM": "3846c905-8ea9-401d-a120-24c00625d626",
                "BLESS_SAC": "48d6f993-15a9-4ce3-8229-f6fb2518b968"
            }
        },
        "HUNTER": {
            "MM": {
                "TURTLE": "bdfc6636-ed1b-4759-805c-f94b7dee458c"
            },
            "SV": {
                "TURTLE": "3a2c34cc-d5b8-43e6-a6fd-95b72c8a42c0"
            },
            "BM": {
                "TURTLE": "9904547d-89a3-49c1-a22b-8477c56d944f"
            }
        },
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {
                "HPPOT": "ef9f4ad9-2f93-446a-b140-4e263547a9ed",
                "PERSONAL2MIN": "574858f4-6ebe-4ee8-a9dc-1969597ab9fc",
                "HS": "f128efa6-46b2-47bc-aa4d-6ba09b4d2f57"
            }
        },
        "WARRIOR": {
            "PROT": {
                "RALLY": "63fd3edd-f182-4277-9bc2-5227448e42a8"
            },
            "FURY": {
                "RALLY": "ddb5c9de-60ed-415c-87fa-d72735ec48e5"
            },
            "ARMS": {
                "RALLY": "eb7f280b-fddb-401b-9231-bc3966bc14bd"
            }
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "PRIEST": {
            "DISC": {
                "RAPT": "a722330c-380a-4b62-9973-2c062379d198",
                "BARRIER": "7168b6ba-1aa8-4a30-b272-d285dfdfd722",
                "EVANG": "36fdf580-d916-40a1-92bc-e09df1094870"
            },
            "HOLY": {
                "HYMN": "2bb38a92-078d-4f43-93fd-9bc84427e9aa",
                "SYMBOL_OF_HOPE": "ee44a41b-1923-4cef-888a-3c74ad5b5739",
                "SALV": "85228257-372c-4385-8ee8-fb461a7a8c04"
            },
            "SHADOW": {
                "EMBRACE": "9aaddd21-d0a6-4b3d-b80a-d477e2404f97"
            }
        },
        "SHAMAN": {
            "ENH": {
                "ANCE_GUIDE": "44fc835d-64fe-4843-9c6b-5a808caf0d86",
                "WRT": "2f13afef-0601-4b78-9bb0-b7067d1ef3e0"
            },
            "ELE": {
                "ANCE_GUIDE": "f1a10dbb-6694-40bb-900a-5832eb7549e8",
                "WRT": "2688e14f-9ab8-4ff1-a94d-e8b1d6ed44d2"
            },
            "RESTO": {
                "ASC": "ede426dc-090c-4de8-9c37-f4b1138f9332",
                "ANCE_GUIDE": "cde29f6d-52dd-49ab-9735-34387e9cb8fc",
                "APT": "f58b02db-feda-424e-8b2a-c2460f5b2fee",
                "WRT": "dde6f793-a6d7-4bb2-bd6d-83b653d842aa",
                "HTT": "cc4bca89-c8c1-4758-a38e-fccd7d68e40b",
                "SLT": "daaf9638-1f3f-450e-a93b-8ee13339503f"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "REVIVAL": "e8bc2271-9314-42f1-a1f5-ae88a8680c48",
                "YULON": "4344685d-b051-42e8-b409-6afdb24e282d",
                "CHI_JI": "135a4fba-6d15-4e2b-b38e-04e3f6ab0db4",
                "COCOON": "ffa5a902-f1f8-4791-b85f-942d98e2b1ab"
            },
            "BRM": {}
        }
    }
}
